export default
  process.env.REACT_APP_ENV === 'prod' ? 'https://proddsbelinux.azurewebsites.net/api/' : 
  process.env.REACT_APP_ENV as any === 'qa' ? 'https://qadsbelinux.azurewebsites.net/api/' :
  process.env.REACT_APP_ENV as any === 'uat' ? 'https://uatdsbelinux.azurewebsites.net/api/' :
  'http://localhost:7071/api/';
